module.exports = "data:image/svg+xml;base64,"